/* eslint prefer-template:0 */

function PackagesUtil(packagesStructure, query) {
    /**
     * @param {string} str
     * @param {string} separator
     * @param {string} equalizer
     * @return {Object.<String, String>}
     */
  function reduceStringToObject(str, separator, equalizer) {
    return (str || '').split(separator).reduce((o, pairString) => {
      const pair = pairString.split(equalizer)
      o[pair[0]] = pair[1]
      return o
    }, {})
  }

  const queryParamsObject = reduceStringToObject(query.replace(/^\?/, ''), '&', '=')

    /**
     * changes the confiIg to load packages correctly, accounting the query
     * @param {Object} config
     * @returns {Object}
     */
  this.buildConfig = function (config) {
    let debug = (queryParamsObject.debug || '').split(',').filter(Boolean)
    if (debug.indexOf('all') !== -1) {
      const debuggableExternals = Object.keys(config.paths).filter(path =>
               config.paths[path].source
            )
      debug = packagesStructure.concat(debuggableExternals)
    }

    function isInDebug(i) {
      return debug.indexOf(i) !== -1
    }

        //config.paths:
    Object.keys(config.paths).filter(k =>
           typeof config.paths[k] === 'object' && !Array.isArray(config.paths[k])
        ).forEach(k => {
          config.paths[k] = config.paths[k][isInDebug(k) ? 'source' : 'min']
        })

        //config.bundles:
    config.bundles = config.bundles || {}
    packagesStructure.filter(pkg => !isInDebug(pkg)).forEach(pkg => {
      config.bundles[pkg] = pkg
      config.paths[pkg] = 'packages-bin/' + pkg + '/' + pkg + '.min'
    })

        //config.packages:
    config.packages = config.packages || []
    const projectPackages = packagesStructure.filter(isInDebug).map(name =>
           ({
             name,
             location: 'packages/' + name + '/src/main',
             main: name
           })
        )
    config.packages = config.packages.concat(projectPackages)

    return config
  }
}

export default PackagesUtil



// WEBPACK FOOTER //
// ./~/santa-main-r/src/main/lib/common/PackagesUtil.js